<template>
    <button
        v-if="loading"
        disabled 
        class="border border-gray-400  bg-gray-400 whitespace-nowrap flex justify-center items-center rounded-md"
    >
        <InfiniteSpinnerSVG icon-class="h-4" />
    </button>
    <button v-else 
        @click="handleButtonClick"
        class="bg-none border border-dark-secondary hover:bg-dark-primary hover:text-gray-100 hover:shadow active:bg-dark-primary active:text-gray-400 text-white bg-dark-secondary whitespace-nowrap flex justify-center items-center rounded-md"
    >
        <slot></slot>    
    </button>
</template>

<script setup>
import { ref, defineProps, defineEmits, watch } from 'vue';
import InfiniteSpinnerSVG from '../svg-components/InfiniteSpinnerSVG.vue';

const props = defineProps(['buttonId', 'buttonResetId', 'clickData'])
const emit = defineEmits(['button-click'])

const loading = ref(false)

watch(() => props.buttonResetId, () => {
    // console.log('watcher: props.buttonResetId')
    if(props.buttonResetId == props.buttonId) {
        loading.value = false
    }
})

function handleButtonClick() {
    loading.value = true
    let data = props.clickData
    data.buttonId = props.buttonId
    emit('button-click', data)
}
</script>